<script setup lang="ts">
import {computed, ref, useAttrs} from "vue"
import ActionButton from "~components/widgets/ActionButton.vue"

 
const props = defineProps({
  source: {type: [Object, Function, String, Number, Array, Boolean] as unknown, required: true},
  label: {type: String, default: "Copy to Clipboard"},
})

const attrs = useAttrs()

const buttonAttrs = computed(() => ({
  size: "sm",
  ...attrs,
}))

const emit = defineEmits(["copied", "error"])

const showCopied = ref(false)

const sourceStr = computed(() => {
  const s = typeof props.source === "function" ? props.source() : props.source
  return JSON.stringify(s)
})

async function copy(): Promise<void> {
  try {
    await navigator.clipboard.writeText(sourceStr.value)
    emit("copied")
    showCopied.value = true
    setTimeout(() => {
      showCopied.value = false
    }, 2000)
  } catch (err) {
    emit("error", err)
    console.error("Copy failed:", err)
  }
}
</script>

<template>
  <span class="copy-button">
    <action-button action="copy" v-bind="buttonAttrs" @click.native="copy">{{ props.label }}</action-button>
    <span v-if="showCopied" class="copied-alert">Copied!</span>
  </span>
</template>

<style lang="scss" scoped>
.copy-button {
  display: inline-flex;
  align-items: center;
}

.copied-alert {
  margin-left: 0.5em;
  color: #28a745;
  font-size: 0.85em;
  font-weight: 600;
  animation: fade-out 2s ease-out forwards;
}

@keyframes fade-out {
  0%   { opacity: 1; }
  70%  { opacity: 1; }
  100% { opacity: 0; }
}
</style>
